import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Button, Panel, Modal, ButtonToolbar } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import reasonCodes from 'config/reason-codes';
import DropdownButton from 'components/ui/tailwind/DropdownButton';

import { isDrayageShipment } from 'helpers/shipment-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

const DATE_FORMAT = 'L LT';

class ShipmentWindowChange extends Component {
  static propTypes = {
    stop: PropTypes.object,
    shipment: PropTypes.object,
    show: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    const {
      stop: { window_start, window_end, appointment_unconfirmed },
    } = props;

    this.state = {
      window_start,
      window_end,
      appointment_unconfirmed,
      name: '',
    };
  }
  UNSAFE_componentWillReceiveProps(props) {
    if (!this.props.show && props.show) {
      const {
        stop: { window_start, window_end, appointment_unconfirmed },
      } = props;
      this.setState({
        window_start,
        window_end,
        appointment_unconfirmed,
      });
    }
  }

  onReasonSelect(reason) {
    this.setState({ value: reason.value, name: reason.name });
  }

  onStopWindowOpenChange = (timeStamp) => {
    this.setState({ window_start: timeStamp });
  };
  onStopWindowCloseChange = (timeStamp) => {
    this.setState({ window_end: timeStamp });
  };

  onToggleAppointmentConfirmed = (e) => {
    const {
      target: { checked },
    } = e;

    this.setState({
      appointment_unconfirmed: !checked,
    });
  };

  closeModal() {
    this.setState(
      {
        value: '',
        name: '',
        window_start: null,
        window_end: null,
        appointment_unconfirmed: false,
      },
      this.props.onHideModal(),
    );
  }

  renderBody() {
    const { window_start, window_end } = this.state;

    const { shipment, stop, t } = this.props;

    const showConfirmCheckbox = isDrayageShipment(shipment) && !stop.empty;
    return (
      <div>
        <Panel>
          <div className="flex flex-wrap -mx-4">
            <div className="px-4">
              <strong>{t('PICK_UP')}</strong>
            </div>
            <div className="px-4 md:w-1/3">
              <label className="w-full form-label mb-2">
                {t('START')}
              </label>
              <DatePicker
                className="w-full form-field mb-4"
                dateFormat={DATE_FORMAT}
                isClearable
                placeholderText={t('WINDOW_START')}
                onChange={this.onStopWindowOpenChange}
                selected={getMomentDate(window_start)}
                timeIntervals={15}
                showTimeSelect
              />
            </div>
            <div className="px-4 md:w-1/3">
              <label className="w-full form-label mb-2">
                {t('END')}
              </label>
              <DatePicker
                className="w-full form-field mb-4"
                timeIntervals={15}
                dateFormat={DATE_FORMAT}
                isClearable
                onChange={this.onStopWindowCloseChange}
                placeholderText={t('WINDOW_END')}
                selected={getMomentDate(window_end)}
                showTimeSelect
              />
            </div>
            {showConfirmCheckbox && (
              <div>
                <label className="w-full form-label mb-2 block">
                  {t('CONFIRMED')}
                </label>
                <input
                  type="checkbox"
                  checked={!this.state.appointment_unconfirmed}
                  onChange={this.onToggleAppointmentConfirmed}
                />
              </div>
            )}
          </div>
        </Panel>
        <Row style={{ marginTop: 10 }}>
          <Col xs={5}>
            <p>{t('SELECT_REASON_FOR_WINDOW_CHANGE')}</p>
          </Col>
          <Col xs={7}>
            <div className="z-100">
              <DropdownButton
                onSelect={(reason) => this.onReasonSelect(reason)}
                items={reasonCodes}
                title={this.state.name || t('SELECT_REASON')}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    if (!this.props.stop) return null;
    const { t } = this.props;
    const stop = this.props.stop;
    const body = this.props.show ? this.renderBody() : null;

    return (
      <Modal show={this.props.show} onHide={() => this.props.onHideModal()} enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t('STOP_WINDOW_CHANGE_SEQUENCE', { sequence: stop.sequence })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={12}>
              <ButtonToolbar style={{ float: 'right' }}>
                <Button onClick={() => this.closeModal()}>
                  {t('CANCEL')}
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={() => {
                    this.props.onSave(this.state);
                    this.props.onHideModal();
                  }}
                  disabled={
                    this.state.reason === '' && this.state.description === ''
                  }
                >
                  {t('UPDATE_JOB')}
                </Button>
              </ButtonToolbar>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

ShipmentWindowChange.propTypes = {
  onHideModal: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  stop: PropTypes.shape({
    window_start: PropTypes.string,
    window_end: PropTypes.string,
  }).isRequired,
};

function getMomentDate(dateStr) {
  if (!dateStr) {
    return null;
  }

  return moment(dateStr);
}

export default withTranslation()(ShipmentWindowChange);
